import { useQuery } from 'react-query';
import { Feedback } from '@repo/types/feedback';
import { httpClient } from '../../../utils/http/http-client';

export const useGetFeedback = (id: number | undefined) =>
  useQuery(
    ['getFeedback'],
    () => httpClient.GET<undefined, Feedback[]>(`release/${id}/feedback`),
    { enabled: Boolean(id) },
  );
